


import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Card from "../../../common/Card";
import PannelHeader from "../../../fragments/PannelHeader";

import classes from './AddAlerts.module.css'
import CopyText from "../../../fragments/CopyText";
import PannelBody from "../../../fragments/PannelBody";
import Button from "../../../common/Button";
import TextareaBox from "../../../common/interactive/TextareaBox";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import { createAlertApi } from "../../../../lib/fetchApi";
import { formatPatientName } from "../../../../lib/patientName";
import { filterActions } from "../../../../store/filter";

export default function AddAlerts({closeModal, directData, inWorkQ}) {
    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(false)
    const [filteredNoteActionsText, setFilteredNoteActionsText] = useState(null) 

    let activeCase = useSelector(state => state.case.activeCase)

    if (directData) {
        activeCase = directData
    }
    const userToken = useSelector(state => state.user.token)

    const closeModalHandler = () => {
        if (closeModal) {
            closeModal()
        }
    }

    function setNotesHandler(value) {
        setFilteredNoteActionsText(value.data.value)
    }


    const submitHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            const reqBody = {
                note: data.notes_textarea,
            }

            let create = await createAlertApi(userToken, activeCase.case.id, reqBody)
            if (create?.errorMessage) {
                dispatch(notificationActions.setError(create))
            } else {
                if (closeModal) {
                    closeModal()
                }

                if (!inWorkQ) {
                    let dispatchBody = {
                        folder: 'case_alerts',
                        item: create
                    }
                    dispatch(caseActions.setInitialDataInArray(dispatchBody))
                } else {
                    let dispatchBody = {
                        case_id: directData?.case?.id,
                        folder: 'case_alerts',
                        item: create
                    }
                    dispatch(filterActions.pushWholeItemInArray(dispatchBody))
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    return <Card>
        <div className={classes.container}>
            <PannelHeader padding='large'>
                <div className={classes.flex_container}>
                    <h2>Add an alert</h2>
                    <button onClick={closeModalHandler} className={classes.close_modal}>
                        <i className="ti ti-x"></i>
                        <span className="sr-only">close modal</span>
                    </button>
                </div>
            </PannelHeader>
            <div className={classes.pacient_details_info}>
                <div className={classes.name}>
                    {directData && directData.patient && <>{directData.patient.name}</>}
                    {!directData && activeCase?.patient && <>{formatPatientName(activeCase.patient)}</>}                  
                </div>
                <div className={classes.copy_text_box}>
                    Case: 
                    <CopyText text={activeCase?.case?.id}/>
                </div>
            </div>
            <PannelBody padding='large'>
                <form onSubmit={submitHandler}> 
                    <div className={classes.item}>
                        <TextareaBox label={'Notes'} name={'notes_textarea'} currentValue={filteredNoteActionsText} action={setNotesHandler}/> 
                    </div>                             
                    <div className={classes.item}>
                        <Button isLoading={isLoading}>
                            Submit <i className="ti ti-chevron-right"></i>
                        </Button>   
                    </div>                     
                </form>                
            </PannelBody>
        </div>
    </Card>
}